function RoundedHome({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.75 0.5H3.25C2.03906 0.5 0.75 1.75 0.75 3V10.5C0.75 13 3.25 13 3.25 13H4.5V18L9.5 13C9.5 13 14.5391 13 15.75 13C16.9609 13 18.25 11.6719 18.25 10.5V3C18.25 1.78906 17 0.5 15.75 0.5Z" fill=${`"${col}"`}/>
    </svg>
  `;
  return baseXml;
}

export default RoundedHome;
